import type { Catalogue } from "./catalogue";
import en from "./en.json";

/** Every language we have words for. Add `hi-IN.json` here; missing codes fall back to English. */
export const catalogue: Catalogue = { en };
